// extracted by mini-css-extract-plugin
module.exports = {"PostDrop":"AssignmentConfirmation_PostDrop__1yYL9","PostDrop-icon":"AssignmentConfirmation_PostDrop-icon__3KV6a","PostDrop-title":"AssignmentConfirmation_PostDrop-title__14s_Z"};